<template>
  <div class="car-add-form-container">
    <div class="page-title-container lighter-shadow" style="text-align: center;">
      <i class="fas fa-key icon"></i>
      <h1>Смяна на парола</h1>
    </div>
    <form class="page-content lighter-shadow" style="padding-top: 20px;">
      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'username'"
                 :name="'username'"
                 :label="'Потребителско име'"
                 :placeholder="'Въведете потребителско име'"
                 :showError="shouldShowError('username')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('username')" :text="errors['username']"/>

      <SelectDropDown v-if="userRoles"
                      class="input"
                      :id="'userRolesDropdown'"
                      :name="'role'"
                      :options="userRolesOptions"
                      :placeholder="'Изберете роля'"
                      :label="'Роля'"
                      :selector="'name'"
                      :defaultSelected="userRolesOptions[2]"
                      @selection-change="setAttribute"
      />

      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'password'"
                 :name="'password'"
                 :label="'Нова парола'"
                 :hidden="true"
                 :placeholder="'Въведете новата парола'"
                 :showError="shouldShowError('newPassword')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('newPassword')" :text="errors['newPassword']"/>

      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'repeatPassword'"
                 :name="'repeatPassword'"
                 :label="'Повторете новата парола'"
                 :hidden="true"
                 :placeholder="'Повторете новата парола'"
                 :showError="shouldShowError('repeatPassword')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('repeatPassword')" :text="errors['repeatPassword']"/>

      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'firstName'"
                 :name="'firstName'"
                 :label="'Име'"
                 :placeholder="'Въведете име'"
                 :showError="shouldShowError('firstName')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('firstName')" :text="errors['firstName']"/>

      <InputText class="input"
                 @value-change="setAttribute"
                 :id="'lastName'"
                 :name="'lastName'"
                 :label="'Фамилия'"
                 :placeholder="'Въведете фамилия'"
                 :showError="shouldShowError('lastName')">
      </InputText>
      <ErrorInput class="error" v-if="shouldShowError('lastName')" :text="errors['lastName']"/>

      <Button class="save-button"
              @click.native="createUser"
              :color="'green'"
              :text="'Запази'"
              :icon="'fa fa-save'"></Button>
    </form>
  </div>
</template>

<script>
import InputText from "@/shared/components/form/InputText";
import Button from "@/shared/components/button/Button";
import ErrorInput from "@/shared/components/form/ErrorInput";
import redirectService from "@/services/redirect.service";
import authorizationService from "@/services/authorization.service";
import SelectDropDown from "@/shared/components/form/SelectDropDown";
import {mapGetters} from "vuex";
import {cloneDeep} from "lodash";

export default {
  name: "UserAddForm",
  components: {SelectDropDown, ErrorInput, Button, InputText},
  created() {
    authorizationService.checkIsLoggedIn();
    this.$store.dispatch('fetchUserRoles');
  },
  data() {
    return {
      username: null,
      role: null,
      password: null,
      repeatPassword: null,
      firstName: null,
      lastName: null,
      errors: {}
    }
  },
  methods: {
    setAttribute(value) {
      this[value.name] = value.currentValue;
      this.errors[value.name] = null;
    },
    createUser() {
      if (this.password === this.repeatPassword) {
        authorizationService.createUser({
          username: this.username,
          role: this.role ? this.role.id : null,
          password: this.password,
          firstName: this.firstName,
          lastName: this.lastName
        })
            .then(({data}) => redirectService.redirectToUserInfo(data))
            .catch((errors) => this.errors = errors.response.data.errors);
      } else {
        this.errors = {repeatPassword: this.repeatPassword ? 'Паролите трябва да съвпадат' : 'Не може да е празно'};
      }
    },
    shouldShowError(fieldName) {
      return !!(this.errors && this.errors[fieldName]);
    }
  },
  computed: {
    ...mapGetters(['userRoles']),

    userRolesOptions() {
      if (this.userRoles && this.userRoles instanceof Array) {
        let temp = cloneDeep(this.userRoles);
        temp = temp.map(role => ({id: role, name: role}));
        return temp;
      }
      return [];
    }
  }
}
</script>

<style scoped>
.car-add-form-container {
  width: 750px;
  height: fit-content;
  margin: 0 auto 60px auto;
}

.input {
  display: block;
  width: 500px;
  height: 95px;
  margin: 20px auto 0 auto;
}

.error {
  width: 500px;
  margin-top: -7px;
}

.save-button {
  width: 300px;
  height: 60px;
  font-size: 26px;
  margin: 45px;
}

</style>
